export default "__VITE_ASSET__YyfLHbXz__"